import { CircleIconButton as CIButton, PaymentButton } from './PaymentButton';

const CircleIconButton = CIButton;

export default PaymentButton;
export { CircleIconButton };